import { render, staticRenderFns } from "./ViewActionModal.vue?vue&type=template&id=3c4ff9dc"
import script from "./ViewActionModal.vue?vue&type=script&lang=ts"
export * from "./ViewActionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports